export const state = {
  answers: JSON.parse(localStorage['answers'] || null) || {
    1: null,
    2: null
  },
  loading: true
}

export const actions = {

}

export const mutations = {
  setAnswer (state, args) {
    state.answers[args.idx] = args.answer;

    try {
      if (state.answers) {
        localStorage['answers'] = JSON.stringify(state.answers);
      }
    } catch (e) {}
  },
  resetAnswer (state) {
    state.answers = {
      1: null,
      2: null
    }
    try {
      localStorage['answers'] = JSON.stringify(state.answers)
    } catch (e) {}
  },
  setLoading (state) {
    state.loading = true
  },
  setLoaded (state) {
    state.loading = false
  }
}

export const getters = {
  getAnswers (state) {
    return '' + state.answers[1] + state.answers[2];
  }
}
